import React from 'react';
import { SButton, type SButtonProps } from '@chargebee/sting-react';
import { cs } from '@bbkAdminUtils/css-utils';

type Props = Omit<SButtonProps, 'variant'> & { active: boolean };

/**
 * Segmented/radio-style toggle button used in editor option pairs (e.g. Left/Center).
 * The active state uses the solid `primary` variant which has no border, while the
 * inactive `neutral-outline` variant has a 1px border. A transparent 1px border is
 * added on the active state so toggling never changes the rendered width.
 */
export const RadioToggleButton: React.FC<Props> = ({
  active,
  className,
  ...props
}) => (
  <SButton
    aria-pressed={active}
    variant={active ? 'primary' : 'neutral-outline'}
    className={cs(
      active && '!tw-border !tw-border-solid !tw-border-transparent',
      className
    )}
    {...props}
  />
);
